import $ from "jquery";

angular.module("persons_gifts")

    .controller("PersonsGiftsEditCtrl", ['LoginService', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular', 'gridService', '$filter', '$translate', 'modalService', '$uibModal', 'logService',
        function (LoginService, $scope, $rootScope, $state, $stateParams, Restangular, gridService, $filter, $translate, modalService, $uibModal, logService) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("PERSONS_GIFTS_WRITE");
            console.log($stateParams.in_out);
            if ($stateParams.in_out == 'IN') {
                $rootScope.title = $filter('translate')('persons_gifts.in_gifts');
            } else {
                $rootScope.title = $filter('translate')('persons_gifts.out_gifts');
            }
            $scope.viewNotAcceptGiftsLabel = false;

            Restangular.all('Warehouses').getList({ entity_type: "gifts", entity_id: $stateParams.id }).then(function (warehouses) {
                $scope.selectWarehouses = warehouses;
            });


            $scope.person_gift = {
                gift_id: "",
                event_id: "",
                full: false,
                costReadOnly: false,
                show_in_reports: true,
                in_out: $stateParams.in_out,
                not_accept_gifts: false,
                from_person_id: -1,
                to_person_id: -1
            };

            $scope.is_IN = $stateParams.in_out == 'IN';

            $scope.gift_id = 0;
            $scope.selectedGift = "";
            if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {

                $rootScope.breadcrumb = [
                    { title: $filter('translate')('persons_gifts.title'), url: "persons_gifts.list" },
                    { title: $filter('translate')('persons_gifts.title_add') },
                ];

            } else {
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('persons_gifts.title'), url: "persons_gifts.list" },
                    { title: $filter('translate')('persons_gifts.title_edit') },
                ];

                Restangular.one('PersonsGifts', $stateParams.id).get().then(function (result) {
                   
                    $scope.person_gift = result;
                    logService.debug($scope.person_gift);
                    if ($scope.person_gift.from_person_id != null) {
                        Restangular.all("Persons").customGET("GetOnlyPersonSimple", { person_id: $scope.person_gift.from_person_id }).then(function (results) {
                            $scope.search.from_person = {
                                id: results.id,
                                term: results.name + ' ' + results.surname + (results.lastname != null ? ' ' + results.lastname : '')
                            };
                            if ($scope.person_gift.from_position_id != null) {
                                Restangular.all("Positions").customGET("GetOnlyPositionSimple", { position_id: $scope.person_gift.from_position_id }).then(function (res) {
                                    $scope.search.from_position = {
                                        id: res.id,
                                        term: res.FK_positions_tl_positions[0].name
                                    };
                                });
                            }
                        });
                    }
                    if ($scope.person_gift.to_person_id != null) {
                        Restangular.all("Persons").customGET("GetOnlyPersonSimple", { person_id: $scope.person_gift.to_person_id }).then(function (results) {
                            $scope.search.to_person = {
                                id: results.id,
                                term: results.name + ' ' + results.surname + (results.lastname != null ? ' ' + results.lastname : '')
                            };
                            if ($scope.person_gift.from_position_id != null) {
                                Restangular.all("Positions").customGET("GetOnlyPositionSimple", { position_id: $scope.person_gift.to_position_id }).then(function (res) {
                                    $scope.search.to_position = {
                                        id: res.id,
                                        term: res.FK_positions_tl_positions[0].name
                                    };
                                });
                            }
                        });
                    }

                    if ($scope.person_gift.from_person_id == null) $scope.person_gift.from_person_id = -1;
                    if ($scope.person_gift.to_person_id == null) $scope.person_gift.to_person_id = -1;
                    $scope.selectedGift = result.FK_persons_gifts_gifts;
                    $scope.person_gift.costReadOnly = result.gift_id != null && result.FK_persons_gifts_gifts.cost != null;
                    if ($scope.person_gift.costReadOnly)
                        $scope.person_gift.cost = result.FK_persons_gifts_gifts.cost;
                    $scope.person_gift.gift_date = new Date($scope.person_gift.gift_date);
                    $scope.gift_id = $scope.person_gift.gift_id;
                    $scope.initialQuantity = $scope.person_gift.quantity;
                    
                    if ($scope.person_gift.not_accept_gifts) {
                        $scope.viewNotAcceptGiftsLabel = true;
                    } else {
                        $scope.viewNotAcceptGiftsLabel = false;
                    }

                });
            }

            Restangular.all('Gifts').getList().then(function (gifts) {
                $scope.SelectGifts = gifts;
                $scope.SelectGifts.unshift({
                    id: null,
                    name: $filter('translate')('persons_gifts.another_gift')
                });
            });

            var options = {
                searchName: "",
                is_template: false
            };
            Restangular.all('Events/AllEvents').getList(options).then(function (events) {
                $scope.SelectEvents = events;
                $scope.SelectEvents.unshift({
                    id: null,
                    name: $filter('translate')('persons_gifts.no_event')
                });
            });

            $scope.checkQuantity = function () {
                if ($scope.person_gift.gift_id != null && $scope.person_gift.gift_id != "") {
                    Restangular.all('Warehouses').customGET("GetTotalStockInWarehouse", { warehouse_id: $scope.person_gift.warehouse_id, product_id: $scope.person_gift.gift_id, type: "gifts" }).then(function (res) {
                        $scope.totalStock = res;

                        if ($scope.totalStock < parseInt($scope.person_gift.quantity)) {
                            $scope.person_gift.full = true;
                        }
                        else
                            $scope.person_gift.full = false;

                    });
                }
            }

            $scope.selectGift = function (gift) {
                $scope.selectedGift = gift;
                $scope.person_gift.costReadOnly = gift.id != null && gift.cost != null;
                if (gift.cost != null)
                    $scope.person_gift.cost = gift.cost;
                $scope.checkQuantity()
                
            }
            /* Mensaje de que no acepta regalos.*/
            $scope.selectPerson = function (person) {                
                if (person.selected.not_accept_gifts) {
                    $scope.viewNotAcceptGiftsLabel = true;
                } else {
                    $scope.viewNotAcceptGiftsLabel = false;
                }
            }

            $scope.changeWarehouse = function (warehouse_id) {
                $scope.person_gift.warehouse_id = warehouse_id;
            }
            $scope.savePersonGift = function () {                
                if ($scope.search.from_person != null) $scope.person_gift.from_person_id = $scope.search.from_person.id;
                if ($scope.search.to_person != null) $scope.person_gift.to_person_id = $scope.search.to_person.id;
                if ($scope.search.from_position != null) $scope.person_gift.from_position_id = $scope.search.from_position.id;
                if ($scope.search.to_position != null) $scope.person_gift.to_position_id = $scope.search.to_position.id;

                if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {
                    Restangular.all('PersonsGifts').post($scope.person_gift).then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('persons_gifts.save_success'));
                            $state.go("persons_gifts.list");
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                } else {
                    $scope.person_gift.put().then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('persons_gifts.edit_success'));
                            $state.go("persons_gifts.list");
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                }
            }

            $scope.checkDelete = function () {
                var nameGift = $scope.person_gift.name != null ? $scope.person_gift.name : $scope.person_gift.FK_persons_gifts_gifts.name;
                modalService.confirm({
                    title: $filter('translate')('persons_gifts.button_delete'),
                    message: $filter('translate')('persons_gifts.delete_message') + " " + nameGift + "?",
                    onAccept: function () {
                        $scope.person_gift.remove().then(function () {
                            toastr.success($filter('translate')('persons_gifts.delete_success'));
                            $state.go("persons_gifts.list");
                        });
                    }
                });
            };


            $scope.selectImage = function () {
                $("#frmImage").trigger("click");
                $("#frmImage").change(function () {
                    var file = document.querySelector('#frmImage');
                    /*if (file) {
                        var fileReader = new FileReader();
                        fileReader.onload = function (event) {
                            var uri = event.target.result;
                            if (angular.isUndefined($scope.person_gift.FK_persons_gifts_images) || $scope.person_gift.FK_persons_gifts_images == null) $scope.person_gift.FK_persons_gifts_images = {};
                            $scope.person_gift.FK_persons_gifts_images.image = uri;
                            $scope.person_gift.photo = uri;
                            $scope.person_gift.image_id = null; //??
                            if (!$scope.$$phase) $scope.$apply();
                        };
                        fileReader.readAsDataURL(file);
                    } else {
                        logService.debug("entra en el preview.src y no casca?");
                        //preview.src = "";
                    }*/
                });
            };

            $scope.getImage = function () {
                if ($scope.person_gift.FK_persons_gifts_images != null && $scope.person_gift.FK_persons_gifts_images.image != null) {
                    return $scope.person_gift.FK_persons_gifts_images.image;
                } else if ($scope.person_gift.image_id != null) {
                    return "/api/Image/GetImageBmp?id=" + $scope.person_gift.image_id + "&maxW=150&maxH2=150";
                } else {
                    return "assets/img/no-image.png";
                }
            };

            $scope.removeImage = function ($event) {
                $scope.person_gift.image_id = null;
                $scope.person_gift.photo = null;
                if ($scope.person_gift.FK_persons_gifts_images != null) $scope.person_gift.FK_persons_gifts_images.image = null;
                if (typeof ($event) !== "undefined") {
                    $event.preventDefault();
                    $event.stopPropagation();
                }
            };

            $scope.search = {
                "from_person": null,
                "from_position": null,
                "to_person": null,
                "to_position": null,
                positions: [],
                persons: [],
                person_min_length: 3,
                position_min_length: 3
            };

            $scope.getPersonsSearch = function (val) {
                if (val == null) {
                    val = '';
                }
                let ret = [];
                ret = Restangular.all('search/person/' + val).getList().then(function (searchTerms) {
                    return searchTerms;
                });

                return ret;
            };

            $scope.personFromSelected = function ($item, $model, $label) {
                let today = new Date();
                $scope.search.position_min_length = 0;
                Restangular.all("Persons").customGET("GetPositionsFromPerson", { person_id: $item.id }).then(function (results) {
                    if (results.FK_persons_positions_persons != undefined && results.FK_persons_positions_persons.length > 0) {
                        $scope.search.positions = [];
                        angular.forEach(results.FK_persons_positions_persons, function (row) {
                            if (row.to_date >= today || row.to_date == null) {
                                $scope.search.from_position = null;
                                $scope.search.positions.push({
                                    id: row.FK_persons_positions_positions.id, // Este es el position_id de cara a luego usarlo para buscar el correo
                                    term: row.FK_persons_positions_positions.name
                                });
                            }
                        });

                    }
                });
            };
            $scope.personToSelected = function ($item, $model, $label) {
                let today = new Date();
                $scope.search.position_min_length = 0;
                Restangular.all("Persons").customGET("GetPositionsFromPerson", { person_id: $item.id }).then(function (results) {
                    if (results.FK_persons_positions_persons != undefined && results.FK_persons_positions_persons.length > 0) {
                        $scope.search.positions = [];
                        angular.forEach(results.FK_persons_positions_persons, function (row) {
                            if (row.to_date >= today || row.to_date == null) {
                                $scope.search.to_position = null;
                                $scope.search.positions.push({
                                    id: row.FK_persons_positions_positions.id, // Este es el position_id de cara a luego usarlo para buscar el correo
                                    term: row.FK_persons_positions_positions.name
                                });
                            }
                        });

                    }
                });
            };

            $scope.getPositionsSearch = function (val) {
                if (val == null) {
                    val = '';
                }
                let ret = [];
                if ($scope.search.from_person != null && $scope.search.from_person.id !== undefined) {
                    angular.forEach($scope.search.positions, function (row) {
                        if (row.term.includes(val)) {
                            ret.push(row);
                        }
                    });
                } else {
                    ret = Restangular.all('search/position/' + val).getList().then(function (searchTerms) {
                        return searchTerms;
                    });
                }
                return ret;
            };


        }])
;

